module.exports = __webpack_public_path__ + "media/src/application/media/rooms/library3-94b438ffb198c91a1bd27b35d491d1f4.png";